import { render, staticRenderFns } from "./alreadyAllot.vue?vue&type=template&id=37e11bcd&scoped=true&"
import script from "./alreadyAllot.vue?vue&type=script&lang=js&"
export * from "./alreadyAllot.vue?vue&type=script&lang=js&"
import style0 from "./alreadyAllot.vue?vue&type=style&index=0&id=37e11bcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e11bcd",
  null
  
)

export default component.exports